//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import countries from "./countries";
import regions from "./regions";
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      countryOptions: countries,
      country: this.spec.value
    };
  },
  computed: {
    regionField: function regionField() {
      return this.spec.region;
    },
    regionOptions: function regionOptions() {
      return regions[this.country];
    }
  },
  methods: {
    classes: function classes() {
      return this.$classes().concat("g-text-field--hintless");
    }
  }
};